import SupportTab from '../components/SupportTab';

const Support = () => {
  return (
    <div className="p-6">
      <SupportTab />
    </div>
  );
};

export default Support;
